module.exports = __webpack_public_path__ + "static/media/81ca208a-5e26-4bdd-a0c9-2104c9c2fea4.41eeda73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/81ca208a-5e26-4bdd-a0c9-2104c9c2fea4.png
// module id = 1491
// module chunks = 0